module.exports = __webpack_public_path__ + "./assets/img_hushan_color@2x__40c15c44f567c1cdc6ef20b6cd53410d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_hushan_color@2x.jpg
// module id = 626
// module chunks = 12